import { Record } from 'immutable';
import { schema } from 'normalizr';

export const KoreSubscription = new Record({
  iccid: null,
  ip_address: null,
  state: null,
});

export const koreSubscriptionSchema = new schema.Entity(
  'koreSubscriptions',
  {},
  {
    idAttribute: value => value.iccid,
  },
);
